import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
    fetchPublicacion,
    editPublicacion,
    fetchTiposPublicacion,
    fetchVariaciones,
    fetchMotivosRevision,
    seModificaronImagenes,
    setImagesUploader,
    updateListPublicaciones,
    resetPublicaciones,
    fetchAtributosCategoria,
    fetchValoresAtributo
} from '../../../../actions/publicacionesActions';
import {
    deletePublicacionApi,
    updatePublicacionApi,
    updatePublicacionDimensionesBulkApi,
    updatePublicacionPrecioYStockBulkApi,
    updateImagenesApi,
    createImageUrl,
    CargarAtributosApi
} from '../../../../api/axios';
import { setBusquedaGlobalResultados } from '../../../../actions/busquedaGlobalActions';
import { fetchGarantias } from '../../../../actions/garantiasActions';
import { fetchRebate } from '../../../../actions/rebatesActions';
import {
    buildEnvioGratisZonaPayload,
    getEstadoPublicacionFromId,
    hasSelectedEnvioGratisZone,
    parsePublicacion,
    shouldRequireEnvioGratisZones,
} from '../../../../helper/publicacionHelper';
import DatosBasicos from './DatosBasicos';
import PrecioPago from './PrecioPago';
import Entrega from './Entrega';
import Imagenes from './Imagenes';
import Estado from './Estado';
import Garantia from './Garantia'
import '../PublicacionStyles.css';
import PubSectionNav from './PubSectionNav';
import ModalItem from '../../../General/Modal';
import BigSpinner from "../../../General/BigSpinner";
import MiniSpinner from "../../../General/MiniSpinner";
import { toast } from '../../../../utilities/appToast';
import GoBackArrow from '../../../General/GoBackArrow';
import PublicacionesAtributos from './PublicacionesAtributos';
import PropTypes from 'prop-types';
import { canEditDimensionesPublicacion, canEditPrecioPublicacion, canEditMasivaPublicacion } from '../../../../utilities/ABMPublicacion';
import AuditoriaPrecioStock from './AuditoriaPrecioStock';

function normalizeErrorPayload(data) {
    if (typeof data !== 'string') {
        return data;
    }

    const trimmed = data.trim();
    if (!trimmed) {
        return data;
    }

    try {
        return JSON.parse(trimmed);
    } catch {
        let depth = 0;
        let start = -1;
        let inString = false;
        let escaped = false;

        for (let index = 0; index < trimmed.length; index += 1) {
            const char = trimmed[index];

            if (inString) {
                if (escaped) {
                    escaped = false;
                } else if (char === '\\') {
                    escaped = true;
                } else if (char === '"') {
                    inString = false;
                }
                continue;
            }

            if (char === '"') {
                inString = true;
                continue;
            }

            if (char === '{') {
                if (start === -1) {
                    start = index;
                }
                depth += 1;
                continue;
            }

            if (char === '}') {
                depth -= 1;
                if (depth === 0 && start !== -1) {
                    try {
                        return JSON.parse(trimmed.slice(start, index + 1));
                    } catch {
                        break;
                    }
                }
            }
        }
    }

    return data;
}

function showApiErrorsToast(data, fallbackMessage) {
    const normalizedData = normalizeErrorPayload(data);
    const errors = Array.isArray(normalizedData?.errors) ? normalizedData.errors : [];
    const errores = Array.isArray(normalizedData?.errores) ? normalizedData.errores : [];
    const tupleMessages = errores
        .map((error) => {
            if (!error || typeof error !== 'object') return '';
            return error.item2 ?? error.Item2 ?? '';
        })
        .filter(Boolean);

    const messages = tupleMessages.length
        ? tupleMessages
        : errors
            .map((error) => {
                if (typeof error === 'string') return error;
                if (!error || typeof error !== 'object') return '';
                return error.errorMesage ?? error.ErrorMesage ?? error.message ?? error.Message ?? '';
            })
            .filter(Boolean);

    if (!messages.length) {
        toast.error(fallbackMessage);
        return false;
    }

    messages.forEach((message) => toast.error(message));
    return true;
}



// Wrapper para usar hooks en class component
function PublicacionEditWrapper(props) {
  const navigate = useNavigate();
  const { id, idSeller } = useParams();
  const location = useLocation();
  return <PublicacionEdit {...props} navigate={navigate} id={id} idSeller={idSeller} location={location} />;
}

class PublicacionEdit extends React.Component {
        // Normaliza la publicación para el render de BusquedaGlobalResultados
        normalizePublicacionForBusquedaGlobal = (pub) => {
            // Normalización robusta para mostrar solo texto descriptivo
            const getDescripcion = (obj) => {
                if (!obj || typeof obj !== 'object') return obj ?? "";
                return obj.descripcion ?? obj.nombre ?? "";
            };

            // Dejar estado como string original para que el componente visual lo procese correctamente
            return {
                titulo: pub.titulo,
                skuSeller: pub.skuSeller ?? pub.sellerSku,
                skuMarket: pub.skuMarket,
                categoria: pub.descripcionCategoria ?? getDescripcion(pub.categoria),
                precioLista: pub.precioLista,
                precioPromocional: pub.precioPromocional,
                estado: getEstadoPublicacionFromId(pub.estado),
                imagenes: pub.imagenes ?? (pub.imagen ? [pub.imagen] : []),
                idPublicacion: pub.idPublicacion,
                marca: pub.descripcionMarca ?? getDescripcion(pub.marca),
                tipoEntrega: pub.tipoEntrega,
                fechaPublicacion: pub.fechaPublicacion,
                envioGratis: pub.envioGratis,
                descripcionSeller: pub.descripcionSeller,
                tipoPublicacion: getDescripcion(pub.tipoPublicacion),
                stock: pub.stock,
                exceptuado: pub.exceptuado,
            };
        }
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0,
            showModal: false,
            tabs: [
                { name: "Datos Básicos ", icon: "ti-home", content: <DatosBasicos idSeller={this.props.idSeller} id={this.props.id} isEditing={true} /> },
                { name: "Precio y Medio de Pago", icon: "sl-icon-wallet", content: <PrecioPago id={this.props.id} isEditing={true} /> },
                { name: "Entrega ", icon: "sl-icon-globe", content: <Entrega idSeller={this.props.idSeller} id={this.props.id} /> },
                { name: "Imagenes ", icon: "sl-icon-picture", content: <Imagenes idSeller={this.props.idSeller} id={this.props.id} /> },
                { name: "Estado ", icon: "sl-icon-layers", content: <Estado idSeller={this.props.idSeller} id={this.props.id} inCreate={false} return={this.goToPreviousPath} /> },
                { name: "Garantía ", icon: "ti-home", content: <Garantia idSeller={this.props.idSeller} id={this.props.id} isEditing={true} /> },
                { name: "Caracteristicas ", icon: "ti-home", content: <PublicacionesAtributos isEditing={true} /> },
                { name: "Auditoria ", icon: "sl-icon-docs", readOnly: true, content: <AuditoriaPrecioStock idPublicacion={this.props.id} publicacion={this.props.publicacion} /> },
            ],
            isClicked: false,
            publicacionPrevia: [],
            dimensionesPrevias: [],
            refrescarAtributos: true,
            isLoading: true
        };
    }

   componentDidMount() {
    const { idSellerPub } = this.props.location?.state || {};
    this.props.setImagesUploader([], false);
    this.props.fetchPublicacion(this.props.id, this.props.idSeller);

    // ✅ Solo llamo si realmente tengo un seller (caso Sellers tab, etc.)
    if (idSellerPub) {
        this.props.fetchTiposPublicacion(idSellerPub);
    }

    this.props.fetchMotivosRevision();
}

componentDidUpdate(prevProps) {
    // Si cambia el id de la publicación, mostrar spinner y limpiar datos previos y store
    if (this.props.id !== prevProps.id) {
        this.setState({
            isLoading: true,
            publicacionPrevia: [],
            dimensionesPrevias: []
        });
        if (this.props.resetPublicaciones) {
            this.props.resetPublicaciones();
        }
    }

    // ✅ NUEVO: cuando ya tengo la publicación con idSeller y aún no tengo tipos, los pido
    const sellerActual = this.props.publicacion?.idSeller;
    const sellerPrevio = prevProps.publicacion?.idSeller;

    if (
        sellerActual &&                                  // hay seller
        sellerActual !== sellerPrevio &&                 // cambió respecto al render anterior
        (!Array.isArray(this.props.tiposPublicacion) ||  // y no tengo tipos cargados
         this.props.tiposPublicacion.length === 0)
    ) {
        this.props.fetchTiposPublicacion(sellerActual);
    }

    // Cuando llegan los datos nuevos, ocultar el spinner
    if (this.props.publicacion.idPublicacion !== this.state.publicacionPrevia?.idPublicacion) {
        const dims = this.props.publicacion?.dimensiones ?? [];
        this.setState({
            publicacionPrevia: this.props.publicacion,
            dimensionesPrevias: structuredClone(dims),
            isLoading: false
        });
    }

    if (
        !prevProps.publicacion?.tieneRebate &&
        this.props.publicacion?.tieneRebate
    ) {
        this.props.fetchRebate(this.props.id);
    }
}

    onSubmit = async (event) => {
        event.preventDefault();
        this.setState({ isClicked: true });

        let publicacion = { ...this.props.publicacion };
        publicacion.userId = this.props.userId;

        const tiposPublicacion = Array.isArray(this.props.tiposPublicacion) ? this.props.tiposPublicacion : [];
        const tipoActual = publicacion?.idTipoPublicacion;
        const debeValidarTipo = tipoActual !== null && tipoActual !== undefined && tipoActual !== '' && tiposPublicacion.length > 0;
        const tipoValido = !debeValidarTipo || tiposPublicacion.some((tipo) => {
            const tipoId = tipo?.id ?? tipo?.codigo ?? tipo?.idTipoPublicacion;
            return String(tipoId ?? '') === String(tipoActual ?? '');
        });

        if (debeValidarTipo && !tipoValido) {
            toast.error("No existe este tipo de publicación, seleccione otro antes de seguir");
            this.setState({ isClicked: false });
            return;
        }

        if (this.props.userType.isAdminMod || this.props.userType.isCategory) {
            publicacion.estado = this.props.publicacion.estado;
        }

        publicacion = parsePublicacion(publicacion);
        let publicacionInicial = parsePublicacion(this.state.publicacionPrevia);
        const tieneZonaEnvioGratisSeleccionada = hasSelectedEnvioGratisZone(publicacion.zonasEnvioGratis);

        if (publicacion.precioPromocional >= publicacion.precioLista) {
            toast.error("El precio promocional no puede ser igual o mayor al precio de lista");
            this.setState({ isClicked: false });
            return;
        }

        if (shouldRequireEnvioGratisZones(publicacion) && !tieneZonaEnvioGratisSeleccionada) {
            toast.error("Debe seleccionar al menos una zona para envio gratis");
            this.setState({ isClicked: false });
            return;
        }

        const canEditMasiva = canEditMasivaPublicacion(publicacion, publicacionInicial);
        let saveSucceeded = true;

        if (canEditMasiva) {
            saveSucceeded = await this.updatePublicacionMasiva(publicacion);
        }

        const canEditPrecio = canEditPrecioPublicacion(publicacion, publicacionInicial);
        if (canEditPrecio && saveSucceeded) {
            saveSucceeded = await this.updatePrecioYStock(publicacion);
        }

        const canEditDimensiones = canEditDimensionesPublicacion(publicacion, this.state.dimensionesPrevias);
        if (canEditDimensiones && saveSucceeded) {
            saveSucceeded = await this.updateDimensiones(publicacion);
        }
        if (saveSucceeded) {
            saveSucceeded = await this.updateImagenes(publicacion);
        }

        if (!saveSucceeded) {
            this.setState({ isClicked: false });
            return;
        }

        this.props.updateListPublicaciones(this.props.publicaciones, publicacion);

        // Si viene de BusquedaGlobalResultados, actualiza también el estado global
        if (this.props.location?.state?.pathReturn === '/BusquedaGlobalResultados') {
            // Actualiza la publicación en el reducer de búsqueda global, conservando datos originales
            if (this.props.busquedaGlobalResultados) {
                const nuevasPublicaciones = this.props.busquedaGlobalResultados.publicaciones.map(pub => {
                    if (pub.idPublicacion === publicacion.idPublicacion) {
                        // Mezcla los datos: si el edit no trae el campo, usa el original
                        const merged = {
                            ...pub,
                            ...publicacion,
                            categoria: publicacion.categoria ?? pub.categoria,
                            marca: publicacion.marca ?? pub.marca,
                            tipoEntrega: publicacion.tipoEntrega ?? pub.tipoEntrega,
                            estado: typeof publicacion.estado === 'number' ? publicacion.estado : pub.estado
                        };
                        return this.normalizePublicacionForBusquedaGlobal(merged);
                    }
                    return this.normalizePublicacionForBusquedaGlobal(pub);
                });
                const nuevosResultados = {
                    ...this.props.busquedaGlobalResultados,
                    publicaciones: nuevasPublicaciones
                };
                if (this.props.setBusquedaGlobalResultados) {
                    this.props.setBusquedaGlobalResultados(nuevosResultados);
                }
            }
        }

        // Guardar Atributos
        if (this.props.huboCambiosEstructuraAtributosValores) {
            saveSucceeded = await this.cargarAtributos();
            if (!saveSucceeded) {
                this.setState({ isClicked: false });
                return;
            }
        }

        this.setState({ isClicked: false });
        this.goToPreviousPath();
    };

    updatePublicacionMasiva = async (publicacion) => {
        let newPublicacionMasiva = {
            actualizacionMasivaBulk: [{
                idPublicacion: publicacion.idPublicacion,
                observacion: publicacion.observacion,
                titulo: publicacion.titulo,
                ean: publicacion.ean,
                linkYoutube: publicacion.linkYoutube,
                descripcionAmpliada: publicacion.descripcionAmpliada,
                tipoEntrega: publicacion.tipoEntrega[0],
                envioGratis: publicacion.envioGratis,
                categoria: publicacion.categoria,
                marca: publicacion.marca,
                idTipoPublicacion: publicacion.idTipoPublicacion,
                idMotivoRevision: publicacion.idMotivoRevision,
                observacionesRevision: publicacion.observacionesRevision == null ? "" : publicacion.observacionesRevision,
                skuSeller: publicacion.skuSeller,
                envioPropio: publicacion.envioPropio,
                codigoLegibilidad: publicacion.codigoLegibilidad,
                garantiaExtActiva: publicacion.garantiaExtActiva,
                garantiaFabrica: publicacion.garantiaFabrica,
                envioGratisZona: buildEnvioGratisZonaPayload(publicacion)

            }],
            idUser: publicacion.userId
        };

        try {
            await updatePublicacionApi(newPublicacionMasiva);
            toast.success("Publicación Editada");
            return true;
        } catch (err) {
            if (!showApiErrorsToast(err.response?.data, "No pudo editarse la Publicación")) {
                toast.error("No pudo editarse la Publicación");
            }
            return false;
        }
    };

    updateDimensiones = async (publicacion) => {
        let newDimensiones = {
            actualizarDimensiones: [{
                idPublicacion: publicacion.idPublicacion,
                dimensiones: publicacion.dimensiones
            }],
            idUser: publicacion.userId
        };

        try {
            await updatePublicacionDimensionesBulkApi(newDimensiones);
            toast.success("Dimensiones actualizadas");
            return true;
        } catch (err) {
            if (!showApiErrorsToast(err.response?.data, "No se pudo editar las dimensiones")) {
                toast.error("No se pudo editar las dimensiones");
            }
            return false;
        }
    };

    updatePrecioYStock = async (publicacion) => {
        const payload = {
            idUser: this.props.userId,
            actualizarPrecioYStockBulks: [{
                idPublicacion: publicacion.idPublicacion,
                precioLista: publicacion.precioLista,
                precioPromocional: publicacion.precioPromocional,
                stock: publicacion.stock,
                alicuotaIva: Number.parseFloat(publicacion.alicuotaIva),
                alicuotaImpuestoInterno: publicacion.alicuotaImpuestoInterno,
            }]
        };

        try {
            await updatePublicacionPrecioYStockBulkApi(payload);
            toast.success("Los cambios en el precio, stock o alícuotas se guardaron correctamente.");
            return true;
        } catch (err) {
            if (!showApiErrorsToast(err.response?.data, "No se pudo editar precio y stock")) {
                toast.error("No se pudo editar precio y stock");
            }
            return false;
        }
    };

    //updateImagenes = async (event) => {
    updateImagenes = async (publicacion) => {

        if (!this.props.imagesUploader || !this.props.hayCambiosEnImagenes) {
            return true;
        }

        // Copia del estado para trabajar sin mutarlo directamente
        //const updatedImages = this.props.imagesUploader.map(image => ({ ...image }));
        const updatedImages = [...this.props.imagesUploader];

        try {
            // Array de promesas para crear URLs de cada imagen
            const urlRequests = updatedImages.map(async (img, index) => {
                if (img.imagen !== undefined) {
                    const res = await createImageUrl(img.imagen);
                    updatedImages[index] = {
                        ...img,
                        urlImagen: res.url
                    };
                }
            });

            await Promise.all(urlRequests);

            const imagenesBulk = updatedImages.map((img) => {
                const urlImagen = img.urlImagen || img.UrlImagen || "";
                if (!/^https?:\/\//i.test(urlImagen)) {
                    throw new Error("La imagen no quedó accesible por URL");
                }

                return {
                    // La lista del uploader numera desde 0 y la API no acepta posición 0.
                    posicion: img.posicion + 1,
                    urlImagen
                };
            });

            const updateImagenesRequest = {
                idUser: this.props.userId,
                actualizarImagenesBulks: [
                    {
                        idPublicacion: publicacion.idPublicacion,
                        imagenes: imagenesBulk
                    }
                ]
            };

            // Llamada a la API
            await updateImagenesApi(updateImagenesRequest);
            toast.success("Imágenes editadas");
            return true;

        } catch (err) {
            if (!err?.response) {
                toast.error(err?.message || "No pudo editarse");
                return false;
            }
            if (!showApiErrorsToast(err?.response?.data, "No pudo editarse")) {
                toast.error("No pudo editarse");
            }
            return false;
        }
    };


    cargarAtributos = async () => {

        try {
            await CargarAtributosApi(this.props.productoValores);
            toast.success("Características cargadas con éxito");
            return true;
        } catch (err) {
            if (!showApiErrorsToast(err.response?.data, "No se pudo actualizar las Características")) {
                toast.error("No se pudo actualizar las Características");
            }
            return false;
        }
    };


    onDelete = (event) => {
        if (event != null) event.preventDefault();
        this.setState({ isClicked: true })

        const req = deletePublicacionApi(this.props.publicacion.idPublicacion);
        req.then(res => {
            toast.success("Publicación eliminada");
            this.goToPreviousPath({ shouldFetch: true });
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo eliminarse");
        }).finally(() => {
            this.setState({ isClicked: false })
        });
    }

    redirectToSeller() {
        localStorage.removeItem("pagina");
        this.props.navigate(`/Sellers/Editar/${this.props.publicacion.idSeller}`);
    }

    goToPreviousPath = (extraState = null) => {
        const pathReturn = this.props.location?.state?.pathReturn;

        if (pathReturn) {
            this.props.navigate(pathReturn, extraState ? { state: extraState } : undefined);
            return;
        }

        this.props.navigate(-1);
    }

    handleCancel = () => {
        this.goToPreviousPath();
    };

    render() {
        const { publicacion } = this.props;
        const { isCategory, isAdminMod } = this.props.userType;
        const { tabs, activeTab, isClicked, showModal } = this.state;
        const externalLoading = this.props.loadingPublicaciones;
        const caracteristicasTabIndex = tabs.findIndex((tab) => (tab?.name ?? '').toLowerCase().includes('caracter'));

        const publicationTitle = publicacion?.titulo || "Publicación";

        return (
            <div className="container py-2">
                {(this.state.isLoading || externalLoading) ? (
                    <div className="card pub-editor border-0 admin-form-loading d-flex align-items-center justify-content-center py-5">
                        <BigSpinner message="Cargando datos de la publicacion..." />
                    </div>
                ) : (
                    <div className="card pub-editor border-0">
                        <header className="pub-editor__header">
                            <GoBackArrow />
                            <div className="min-w-0">
                                <p className="pub-editor__kicker">Editar publicación</p>
                                <h4 className="pub-editor__title text-truncate">{publicationTitle}</h4>
                                <div className="pub-editor__meta">
                                    {publicacion?.idPublicacion ? (
                                        <span className="pub-editor__id">#{publicacion.idPublicacion}</span>
                                    ) : null}
                                    {(isCategory || isAdminMod) && publicacion?.nombreSeller &&
                                        <button type="button" className="pub-editor__seller" onClick={() => { this.redirectToSeller() }}>
                                            {publicacion.nombreSeller}
                                        </button>
                                    }
                                </div>
                            </div>
                        </header>
                        <div className="pub-editor__body">
                            <div className="pub-editor__workspace">
                                <PubSectionNav
                                    tabs={tabs}
                                    activeTab={activeTab}
                                    onChange={(index) => this.setState({ activeTab: index })}
                                />
                                <form className="pub-editor__form" onSubmit={this.onSubmit}>
                                    <div className="tab-content">
                                        {activeTab !== caracteristicasTabIndex && tabs[activeTab]?.content}

                                        <div style={{ display: activeTab === caracteristicasTabIndex ? 'block' : 'none' }}>
                                            {caracteristicasTabIndex >= 0 ? tabs[caracteristicasTabIndex].content : null}
                                        </div>

                                        <div className="pub-editor__actions publicaciones-edit-actions">
                                                <div hidden={!isClicked}>
                                                    <MiniSpinner />
                                                </div>
                                                <button
                                                    type="submit"
                                                    disabled={isClicked}
                                                    className="btn btn-sm background-rojo-megatone"
                                                >
                                                    Guardar
                                                </button>
                                                {isAdminMod &&
                                                    <ModalItem
                                                        btnText="Eliminar"
                                                        text="¿Desea eliminar esta publicación?"
                                                        onDelete={this.onDelete}
                                                        show={showModal}
                                                        disabled={isClicked}
                                                        btnStyle="btn btn-sm btn-grey"
                                                    />
                                                }
                                                <button
                                                    type="button"
                                                    onClick={this.handleCancel}
                                                    className="btn btn-sm btn-light"
                                                >
                                                    Cancelar
                                                </button>
                                            </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
PublicacionEdit.propTypes = {
    // Hooks props
    location: PropTypes.shape({
        pathname: PropTypes.string,
        state: PropTypes.shape({
            pathReturn: PropTypes.string,
        })
    }),
    navigate: PropTypes.func,
    // Redux props
    idSeller: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    userId: PropTypes.number,
    userType: PropTypes.shape({
        isAdminMod: PropTypes.bool,
        isCategory: PropTypes.bool,
    }),
    publicacion: PropTypes.shape({
        idSeller: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        idPublicacion: PropTypes.number,
        idTipoPublicacion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        dimensiones: PropTypes.array,
        tieneRebate: PropTypes.bool,
        estado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        nombreSeller: PropTypes.string,
    }),
    tiposPublicacion: PropTypes.array,
    busquedaGlobalResultados: PropTypes.shape({
        publicaciones: PropTypes.array,
    }),
    huboCambiosEstructuraAtributosValores: PropTypes.bool,
    imagesUploader: PropTypes.array,
    hayCambiosEnImagenes: PropTypes.bool,
    productoValores: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    loadingPublicaciones: PropTypes.bool,
    publicaciones: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    // Actions props
    setImagesUploader: PropTypes.func,
    fetchPublicacion: PropTypes.func,
    fetchTiposPublicacion: PropTypes.func,
    fetchMotivosRevision: PropTypes.func,
    resetPublicaciones: PropTypes.func,
    fetchRebate: PropTypes.func,
    updateListPublicaciones: PropTypes.func,
    setBusquedaGlobalResultados: PropTypes.func,
}


const mapStateToProps = state => ({
    seller: state.sellers.seller,
    userType: state.general.userType,
    publicacion: state.publicaciones.publicacion,
    tiposPublicacion: state.publicaciones.tiposPublicacion,
    userId: state.general.userId,
    imagesUploader: state.publicaciones.imagesUploader,
    hayCambiosEnImagenes: state.publicaciones.hayCambiosEnImagenes,
    publicaciones: state.publicaciones.publicaciones,
    busquedaGlobalResultados: state.busquedaGlobal.resultados,
    // Use centralized loading flag from publicaciones reducer
    loadingPublicaciones: state.publicaciones.loadingPublicaciones,

    productoValores: state.publicaciones.productoValores,
    huboCambiosEstructuraAtributosValores: state.publicaciones.huboCambiosEstructuraAtributosValores
});



export default connect(mapStateToProps, {
    fetchPublicacion,
    fetchGarantias,
    editPublicacion,
    fetchTiposPublicacion,
    fetchVariaciones,
    fetchMotivosRevision,
    seModificaronImagenes,
    fetchRebate,
    setImagesUploader,
    updateListPublicaciones,
    resetPublicaciones,
    setBusquedaGlobalResultados,
    fetchAtributosCategoria,
    fetchValoresAtributo,
    CargarAtributosApi
})(PublicacionEditWrapper);
